import React, { useState } from "react";
import "./SectionD.css";
import HiMan from "../../assets/finak 1.png";
import Footer from "../Footer/Footer.jsx";

const SecitonD = () => {
  const invalidInputValue = {
    borderColor: "red",
  };

  // const emailStyle = { width: "75%" };
  // const reasonStyle = { resize: "none", width: "75%", height: "4em" };

  const [nameError, setNameError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [reasonError, setReasonError] = useState(false);

  const [nameVal, setNameVal] = useState("");
  const [phoneVal, setPhoneVal] = useState("");
  const [emailVal, setEmailVal] = useState("");
  const [reasonVal, setReasonVal] = useState("");

  const namePatt = /^[A-Za-z]+(\s[A-Za-z]+)*$/;
  const phonePatt = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s/0-9]*$/;
  const emailPatt =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const reasonPatt = /[A-Za-z0-9_]{5,400}/;

  const checkNameVal = (e) => {
    const name = e.target.value;
    setNameVal(name);
    setNameError(!namePatt.test(name));
  };

  const checkPhoneVal = (e) => {
    const phone = e.target.value;
    setPhoneVal(phone);
    setPhoneError(!phonePatt.test(phone));
  };

  const checkEmailVal = (e) => {
    const email = e.target.value;
    setEmailVal(email);
    setEmailError(!emailPatt.test(email));
  };

  const checkReasonVal = (e) => {
    const reason = e.target.value;
    setReasonVal(reason);
    setReasonError(!reasonPatt.test(reason));
  };

  return (
    <>
      <div id="contact" className="section-d-body">
        <div className="contains">
          <div className="contains2">
            <h1 className="wed-love non-selectable">
              We'd love to hear from you!
            </h1>
            <p className="please-text non-selectable">
              Please send us your details so we can contact you :)
            </p>

            <form
              action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSdcjjeCmwBUSm-pxQnE-AKQjq47jmHztlCuypyv5wnBMKR98A/formResponse"
              target="_self"
              method="POST"
              className="form-style"
            >
              <span className="input-label">Name</span>
              <input
                type="text"
                value={nameVal}
                onChange={checkNameVal}
                className="input-style"
                name="entry.2005620554"
                required
                style={nameError ? invalidInputValue : null}
              />
              <span className="input-label">Phone</span>
              <input
                type="tel"
                value={phoneVal}
                onChange={checkPhoneVal}
                className="input-style"
                name="entry.1166974658"
                required
                style={phoneError ? invalidInputValue : null}
              />
              <span className="input-label">Email</span>
              <input
                type="email"
                value={emailVal}
                onChange={checkEmailVal}
                className="input-style email-style"
                name="entry.1045781291"
                required
                style={emailError ? invalidInputValue : null}
              />
              <span className="input-label">Reason for contact</span>
              <textarea
                value={reasonVal}
                onChange={checkReasonVal}
                className="input-style reason-style"
                name="entry.839337160"
                required
                style={reasonError ? invalidInputValue : null}
              />
              <button className="button-style2">Submit</button>
            </form>
          </div>
          <div className="contains2-2 non-selectable">
            <img src={HiMan} alt="Yo" />
          </div>
          <div className="contains3">
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default SecitonD;
